// ==== imports (ONE time) ====
const gsap = window.gsap;
const ScrollTrigger = window.ScrollTrigger;


import "./import/components";
import "./header-stick";
import "./cursor-circle.js";

import initPolyfills from "./modules/polyfills";
import initValuesSection from "./modules/valuesSection";
import initValuesAutoplay from "./modules/valuesAutoplay";
import initPortfolio from "./modules/portfolio";
import { settledTrigger } from './modules/gsap-utils';
import { ScrollSettle } from './modules/scroll-settler';
ScrollSettle.setDelay(250);

import initTeamSliders from "./modules/teamSlider";
import initHeroVideo from './modules/initHeroVideo';
import initBannerAndMenu from "./modules/bannerIntro";
import initNewsSnap from "./modules/newsSnap";
import initDebugToggle from "./modules/debugToggle";
import initHeroCircles from "./modules/heroCircles";
// team
import initTeamOverview from "./modules/team/teamOverview";
import initTeamVideo from "./modules/team/teamVideo";
import initTeamMembers from "./modules/team/teamMembers";
import initTeamValues from "./modules/team/teamValues";
import initTeamCarBanner from "./modules/team/teamCarBanner";
import initPortfolioPage from "./modules/portfolio/portfolio";

// core

document.documentElement.style.setProperty('overflow-anchor', 'none');

import initCoreValues from "./modules/core/coreValues";
import initHeroClusterPattern from "./modules/heroPattern.js";
import initHeroContactPattern from './modules/heroPatternContact.js';


import initContactAjax from './modules/contact-ajax.js'; //

function stabilizeViewportAroundCenter(run) {
    const scEl = document.scrollingElement || document.documentElement;

    // елемент у центрі вьюпорта до змін
    const probeY = Math.floor(window.innerHeight * 0.5);
    const probeX = 10; // від краю, щоб не попасти в порожнечу
    const beforeEl = document.elementFromPoint(probeX, probeY);
    const beforeTop = beforeEl ? beforeEl.getBoundingClientRect().top : 0;

    // виконати ваші ініти/refresh усередині
    run();

    // після всіх перерахунків компенсуємо зсув
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            const afterEl = beforeEl && document.body.contains(beforeEl) ? beforeEl : document.elementFromPoint(probeX, probeY);
            const afterTop = afterEl ? afterEl.getBoundingClientRect().top : 0;
            const delta = afterTop - beforeTop;
            if (delta) scEl.scrollTop += delta;
        });
    });
}

// невеличкий утил для очікування верстки
function whenLayoutReady(cb) {
    // дочекаємось web-fonts
    const fontsReady = (document.fonts && document.fonts.ready ? document.fonts.ready.catch(()=>{}) : Promise.resolve());
    // дочекаємось window.load (картинки/відео)
    const loadReady = new Promise(r => {
        if (document.readyState === 'complete') r(); else window.addEventListener('load', () => r(), { once: true });
    });
    Promise.all([fontsReady, loadReady]).then(() => {
        requestAnimationFrame(() => requestAnimationFrame(cb));
    });
}


// ==== setup/debug (use a single copy) ====
window.__DEBUG = /[?&]debug=1/.test(location.search);

// gsap global config
gsap.config({ nullTargetWarn: false });

// small helper
const $ = (s, r = document) => r.querySelector(s);


// disable browser scroll restoration
try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch(e){}

// GSAP config (после registerPlugin)
if (ScrollTrigger) {

    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.config({
        limitCallbacks: true,
        ignoreMobileResize: true,
        autoRefreshEvents: "visibilitychange"
    });

}

if (window.__DEBUG && ScrollTrigger) {
    ScrollTrigger.defaults({ markers: true });
    console.info("[DEBUG] enabled (use ?debug=1)");
}

// guard against auto-jump by hash on first load
if (location.hash) {
    requestAnimationFrame(() => {
        try { history.replaceState(null, "", location.pathname + location.search); } catch(e){}
    });
}


// user interaction flag for “no auto-scroll on load”
window.__USER_SCROLLED__ = false;
['touchstart','wheel','keydown','mousedown'].forEach(ev => {
    window.addEventListener(ev, () => window.__USER_SCROLLED__ = true, { passive:true });
});
window.addEventListener('scroll', () => window.__USER_SCROLLED__ = true, { passive:true });

// ==== boot ====
initPolyfills();



document.addEventListener("DOMContentLoaded", () => {
    initDebugToggle();

    if (document.querySelector(".circles-canvas[data-circles]")) {
        initHeroCircles();
    }
    if (document.querySelector(".hero-news[data-hero-news]")) {
        initHeroClusterPattern();
    }
    if (document.querySelector(".hero-contact[data-hero-contact]")) {
        initHeroContactPattern();
    }
    const contactPage = $('body.page-template-page-contact');
    if (contactPage) {
        initContactAjax();
    }


    const teamPage = $("body.page-template-page-team, body.page-template-page-team-php");
    if (teamPage) {
        initTeamOverview('.team-overview', '.ov-text');
        initTeamVideo();
        initTeamMembers();
        initTeamValues();
        initTeamCarBanner();
    }

    const portfolioPage = $("body.page-template-page-portfolio, body.page-template-page-portfolio-php");
    if (portfolioPage) {
        initPortfolioPage();
    }

    const coreValuesPage = $('body.page-template-page-core-values, body.page-template-page-core-values-php');
    if (coreValuesPage) {
        initTeamOverview('.team-overview.team-overview--core', '.ov-text'); // той самий модуль
        initCoreValues();
    }


    initBannerAndMenu();
    const home = document.querySelector(".home");
    if (home) {

        initValuesSection();
        initValuesAutoplay();
        initPortfolio();
        initTeamSliders();
        initHeroVideo(document);
        initNewsSnap();

        const tlHero = gsap.timeline({ defaults:{ duration:0.6, ease:'power2' } })
            .from('.hero .title', { y:30, autoAlpha:0 })
            .from('.hero .subtitle', { y:20, autoAlpha:0 }, '-=0.3');

        settledTrigger({ trigger: '.hero', start: 'top 80%', once: true }, tlHero, 250);

        // === головне: один керований refresh + компенсація скролу
        whenLayoutReady(() => {
            stabilizeViewportAroundCenter(() => {
                if (window.ScrollTrigger) ScrollTrigger.refresh(true);
            });
            // ✅ повертаємо anchoring лише після стабілізації лейаута
            requestAnimationFrame(() => {
                document.documentElement.style.removeProperty('overflow-anchor');
            });
        });
    }
});



